export default __webpack_public_path__ + "static/media/640_store04-it-web.e5d15c07.png";